import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";

import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import NewGif from "../../Assets/new.gif";
import { useSelector } from "react-redux";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import CheckIcon from "@mui/icons-material/Check";
import useStudent from "../../hooks/useStudent";
const apiUrl = process.env.REACT_APP_API_URL

const Home = () => {
  const [papers, setPapers] = useState([]);
  const navigate = useNavigate();
  const [listOfAttemptedPapers, setListOfAttemptedPapers] = useState([]);
  const [backdropState, setBackdropState] = useState(false);
  const [show, setShow] = useState("approved");
  const [showQuestionPaper, setShowQuestionPaper] = useState(true);

  const { student } = useSelector((state) => state.auth.student);
  //localStorage.setItem("studentId",student)
  //console.log("student", student);
  // optimized one
  async function getPapers() {
    setBackdropState(true);
    try {
      const QuestionPaperResponse = await fetch(
        `${apiUrl}/api/question-paper-toggle`
      );
      const QuestionPaperData = await QuestionPaperResponse.json();
      if (!QuestionPaperData.data.isOn) {
        setShowQuestionPaper(false);
        setBackdropState(false);
        return;
      }
      const paymentResponse = await fetch(
        `${apiUrl}/get-student/${student._id}`
      );
      const paymentData = await paymentResponse.json();
      if (paymentData.student.paymentStatus !== "approved") {
        setShow(paymentData.student.paymentStatus);
        setBackdropState(false);
        return;
      }
      const [samplePapers, currentStudent] = await Promise.all([
        axios.get(`${apiUrl}/get-sample-papers`),
        axios.get(`${apiUrl}/get-result/${student._id}`),
      ]);
      console.log("samplePaper", samplePapers);
      if (currentStudent.data.student) {
        const allAttemptedPapers =
          currentStudent?.data?.student.quizResults?.map((paper, index) => {
            return paper.solvedPaperId;
          });
        setListOfAttemptedPapers(allAttemptedPapers);
      }

      // fetching the paper for the open category students
      if (currentStudent.data.student.enrollmentStatus === "open") {
        if (samplePapers.data.question.length) {
          const studentGrade = currentStudent?.data?.student?.grade;

          const allPapers = samplePapers.data.question;
          const onlySamplePapers = allPapers.filter((question, index) => {
            if (studentGrade === 1 || studentGrade === 2) {
              return (
                question.paperType === "sample" &&
                question.level === 1 &&
                question.category === student?.category
              );
            } else if (studentGrade === 3) {
              return (
                question.paperType === "sample" &&
                question.level === 2 &&
                question.category === student?.category
              );
            } else if (studentGrade === 4) {
              return (
                question.paperType === "sample" &&
                question.level === 3 &&
                question.category === student?.category
              );
            } else if (studentGrade === 5) {
              return (
                question.paperType === "sample" &&
                question.level === 4 &&
                question.category === student?.category
              );
            } else if (studentGrade === 6) {
              return (
                question.paperType === "sample" &&
                question.level === 5 &&
                question.category === student?.category
              );
            } else if (studentGrade === 7) {
              return (
                question.paperType === "sample" &&
                question.level === 6 &&
                question.category === student?.category
              );
            } else if (studentGrade === 8) {
              return (
                question.paperType === "sample" &&
                question.level === 7 &&
                question.category === student?.category
              );
            } else if (studentGrade === 9) {
              return (
                question.paperType === "sample" &&
                question.level === 8 &&
                question.category === student?.category
              );
            }
          });

          setBackdropState(false);
          setPapers(onlySamplePapers);
        }
        setBackdropState(false);

        return;
      }

      if (samplePapers.data.question.length) {
        const allPapers = samplePapers.data.question;
        const onlySamplePapers = allPapers.filter((question, index) => {
          return (
            question.paperType === "sample" &&
            question.level === student?.lastCompletedLevel &&
            question.category === student?.category
          );
        });
        console.log("only", onlySamplePapers);
        setPapers(onlySamplePapers);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setBackdropState(false);
    }
  }

  async function startTest(questions, paperId, { paperType }) {
    setBackdropState(true);
    try {
      const res = await axios(
        `${apiUrl}/get-student/${student._id}`
      );
      if (res.data.student) {
        if (res.data.student.paymentStatus === "pending") {
          toast.warning("Please Complete the payment to proceed further!");
          setBackdropState(false);

          return;
        } else {
          setBackdropState(false);

          navigate("/questions", { state: { questions, paperId, paperType } });
        }
      }
    } catch (error) {
      setBackdropState(false);

      toast.warning("Something went wrong!");
    }
  }
  useEffect(() => {
    new Date().toLocaleDateString();
    new Date("6/3/2023").toLocaleDateString() && getPapers();
    getPapers();
  }, []);

  return (
    <div className="flex min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      <Sidebar />
      <div className="flex-1 flex flex-col">
        <Navbar />
        <div className="p-6 flex-1">
          {/* Breadcrumb */}
          <nav className="flex mb-6" aria-label="Breadcrumb">
            <ol className="inline-flex items-center space-x-2">
              <li className="inline-flex items-center">
                <span className="text-sm font-medium text-gray-500">
                  Student
                </span>
              </li>
              <li>
                <div className="flex items-center">
                  <svg
                    className="w-4 h-4 mx-1 text-gray-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="text-sm font-medium text-blue-600">
                    Sample Papers
                  </span>
                </div>
              </li>
            </ol>
          </nav>

          {/* Main Content */}
          <div className="bg-white rounded-xl shadow-md overflow-hidden p-6">
            {show === "pending"  ? (
              <div className="text-center py-12">
              <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-yellow-100 mb-4">
                <svg
                  className="h-8 w-8 text-yellow-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-800 mb-2">
                Payment Pending
              </h2>
              <p className="text-gray-600 mb-6 max-w-md mx-auto">
                Please complete your payment to access the sample papers.
              </p>
            </div>
            ) : showQuestionPaper && show==="approved" ? (
              <div className="mt-8">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">
                  Available Sample Papers
                </h3>
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          S.No
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Category
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Level
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Type
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Questions
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Status
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {papers.length > 0 ? (
                        papers.map((paper, index) => (
                          <tr
                            key={paper._id}
                            className="hover:bg-gray-50 transition-colors"
                          >
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              {index + 1}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                              {paper.category === "sr" ? "Senior" : "Junior"}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              {paper.level}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 capitalize">
                              {paper.paperType}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              {paper.questions.length}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <span
                                className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                                  listOfAttemptedPapers?.includes(paper._id)
                                    ? "bg-green-100 text-green-800"
                                    : "bg-blue-100 text-blue-800"
                                }`}
                              >
                                {listOfAttemptedPapers?.includes(paper._id)
                                  ? "Attempted"
                                  : "New"}
                              </span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                              <button
                                onClick={() =>
                                  startTest(paper.questions, paper._id, paper)
                                }
                                className={`inline-flex items-center px-4 py-2 rounded-md shadow-sm text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 ${
                                  listOfAttemptedPapers?.includes(paper._id)
                                    ? "text-blue-700 bg-blue-50 hover:bg-blue-100 focus:ring-blue-500"
                                    : "text-white bg-blue-600 hover:bg-blue-700 focus:ring-blue-500"
                                }`}
                                aria-label={
                                  listOfAttemptedPapers?.includes(paper._id)
                                    ? "Review test"
                                    : "Start test"
                                }
                              >
                                <PlayArrowIcon className="-ml-1 mr-2 h-4 w-4" />
                                {listOfAttemptedPapers?.includes(paper._id)
                                  ? "Attempt Again"
                                  : "Start Test"}
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="7"
                            className="px-6 py-4 text-center text-sm text-gray-500"
                          >
                            No papers available at the moment
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="text-center py-12">
                <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-yellow-100 mb-4">
                  <svg
                    className="h-8 w-8 text-yellow-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                    />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-gray-800 mb-2">
                  Dear,{" "}
                  <span className="text-blue-600">{student.firstname}</span>
                </h2>
                <p className="text-gray-600 mb-6 max-w-md mx-auto">
                 Sample papers will be available at your scheduled time.
                  {/* Sample papers have been closed now. Final papers will be
                  available at your scheduled time. */}
                </p>
                <Link
                  to="/final-papers"
                  className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 transition-colors duration-200"
                >
                  View Final Papers
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdropState}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default Home;